export default __webpack_public_path__ + "static/media/man.0f21c341.png";